
















import {Component, Prop, Vue} from 'vue-property-decorator';
import ObjectSidebarHide from "@share/object-sidebar/ObjectSidebarHide.vue";
import ObjectSidebarShow from "@share/object-sidebar/ObjectSidebarShow.vue";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

export type SwitchersTypes = 'desktop' | 'mobile';

@Component({
    name: 'ObjectViewLayout',
    components: { ObjectSidebarShow, ObjectSidebarHide }
})
export default class ObjectViewLayout extends Vue {
    //hides the buttons which switching sidebar visibility, sets is-right-side-hidden permanently
    @Prop({ default: false }) isOneColumn: boolean;

    switchersTypes: SwitchersTypes[] = ['desktop', 'mobile'];

    isRightSideHidden = false;
    isRightSideMobileHidden = true;

    get showSwitcher() {
        return !this.isOneColumn && this.$route.name != RouteNamesEnum.viewMeetingPublic;
    }

    toggleState(type: SwitchersTypes, state: boolean) {

        this.$emit('sidebarVisibilityChange', { type, state })
        if (type == 'desktop') {
            this.isRightSideHidden = state;
        }
        if (type == 'mobile') {
            this.isRightSideMobileHidden = state;

            if(!state) {
                document.body.classList.add("no-scroll")
            }
            else {
                document.body.classList.remove("no-scroll")
            }
        }
    }

    onHide(type: SwitchersTypes) {
        this.toggleState(type, true);
    }

    onShow(type: SwitchersTypes) {
        this.toggleState(type, false);
    }
}
